/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["del mediodía", "de la madrugada", "de la mañana", "de la tarde", "de la noche"], ["mediodía", "madrugada", "mañana", "tarde", "noche"], u], [["m.", "madrugada", "mañana", "tarde", "noche"], ["mediodía", "madrugada", "mañana", "tarde", "noche"], u], ["12:00", ["00:00", "06:00"], ["06:00", "12:00"], ["12:00", "20:00"], ["20:00", "24:00"]]];
